<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <LoadingComponent :loading="loadingResumo" style="z-index: 1000;" />
    <v-container class="toolbar__container">
      <v-form ref="form">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <LazySelect
              ref="empresaSelect"
              get-url="getEmpresaslazy"
              text="razao_social"
              value="id_empresa"
              :label="$tc('company.self', 1)"
              @input="onEmpresaInput"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <MultiplaEscolha
              ref="unidadesSelect"
              lazy
              get-url="getUnidadeslazy"
              :items="semUnidadeOption"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <MultiplaEscolha
              ref="linhasSelect"
              lazy
              get-url="getLinhaslazy"
              v-bind:selected-items.sync="idLinhaSelected"
              text="nome_linha"
              value="id_linha"
              :label="$tc('line.self', 1)"
              :max-items="2"
            />
          </v-col>
          <v-col cols="12" sm="2" md="2" class="d-flex align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="populaRelatorio"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!resumoCompleto"
                  :loading="loadingPdf"
                  @click="exportarAnalisePdf"
                >
                  <v-icon>mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('diagDataInconsistencies.exportPdf') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <div v-if="loadingPdf" class="pdf-export-overlay">
      <div class="text-center white--text">
        <v-progress-circular indeterminate color="white" size="48" class="mb-3" />
        <div>{{ $t('diagDataInconsistencies.exportingPdf') }}</div>
      </div>
    </div>

    <div v-if="hasKpis" ref="sectionContent">
      <v-row class="mt-4 mb-2">
        <v-col
          v-for="card in kpiCards"
          :key="card.key"
          cols="12"
          sm="6"
          md="3"
          class="d-flex"
        >
          <v-card
            class="pa-3 flex-grow-1"
            style="border-radius: 10px; cursor: pointer;"
            :outlined="activeKpiFilter !== card.key"
            :color="activeKpiFilter === card.key ? 'primary lighten-5' : undefined"
            @click="onKpiClick(card)"
          >
            <div class="text-caption grey--text text--darken-1">{{ card.label }}</div>
            <div class="text-h5 font-weight-bold" :style="{ color: card.color }">
              <v-progress-circular
                v-if="card.value === undefined"
                indeterminate
                size="20"
                width="2"
                :color="card.color"
              />
              <template v-else>{{ card.value === null ? '—' : card.value }}</template>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-card class="mt-2" style="border-radius: 10px;">
      <v-tabs v-model="tab" background-color="transparent" color="primary">
        <v-tab>{{ $t('diagDataInconsistencies.tabs.vehiclesEquipment') }}</v-tab>
        <v-tab>{{ $t('diagDataInconsistencies.tabs.vehiclesSchedule') }}</v-tab>
        <v-tab>{{ $t('diagDataInconsistencies.tabs.linesSchedule') }}</v-tab>
        <v-tab>{{ $t('diagDataInconsistencies.tabs.linesRoutesFences') }}</v-tab>
        <v-tab>{{ $t('diagDataInconsistencies.tabs.passengers') }}</v-tab>
        <v-tab>{{ $t('diagDataInconsistencies.tabs.linesEndpoints') }}</v-tab>
        <v-tab>{{ $t('diagDataInconsistencies.tabs.employees') }}</v-tab>
        <v-tab>{{ $t('diagDataInconsistencies.tabs.linesUnits') }}</v-tab>
        <v-tab>{{ $t('diagDataInconsistencies.tabs.passengersBoarding') }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <merus-data-table
            :key="`${tableKey}-eq`"
            cod-tabela="DIAGINCONSISTENCIADADOS__VEICULOS_EQUIPAMENTOS"
            :headers="headersVeiculosEquipamentos"
            :items="veiculosEquipamentos"
            :loading="loadingVeiculosEquipamentos"
            item-key="id_veiculo"
            @update:headers="headersVeiculosEquipamentos = $event"
          >
            <template v-slot:toolbar>
              <CadastroToolbar
                :title="$t('diagDataInconsistencies.tabs.vehiclesEquipment')"
                :token="token"
                :items="veiculosEquipamentos"
                csv-title="diaginconsistenciaveiculosequipamentos"
                :csv-headers="headersVeiculosEquipamentos"
                :pdf-title="$t('diagDataInconsistencies.tabs.vehiclesEquipment')"
                :pdf-headers="headersVeiculosEquipamentos"
                pdf-filename="diaginconsistenciaveiculosequipamentos"
                hide-search
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="primary"
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirResolucao('veiculosEquipamentos', item)"
                  >mdi-open-in-new</v-icon>
                </template>
                <span>{{ $t('diagDataInconsistencies.resolveTo.veiculosEquipamentos') }}</span>
              </v-tooltip>
            </template>
          </merus-data-table>
        </v-tab-item>
        <v-tab-item>
          <merus-data-table
            :key="`${tableKey}-vp`"
            cod-tabela="DIAGINCONSISTENCIADADOS__VEICULOS_PROGRAMACAO"
            :headers="headersVeiculosProgramacao"
            :items="veiculosProgramacao"
            :loading="loadingVeiculosProgramacao"
            item-key="id_veiculo"
            @update:headers="headersVeiculosProgramacao = $event"
          >
            <template v-slot:toolbar>
              <CadastroToolbar
                :title="$t('diagDataInconsistencies.tabs.vehiclesSchedule')"
                :token="token"
                :items="veiculosProgramacao"
                csv-title="diaginconsistenciaveiculosprogramacao"
                :csv-headers="headersVeiculosProgramacao"
                :pdf-title="$t('diagDataInconsistencies.tabs.vehiclesSchedule')"
                :pdf-headers="headersVeiculosProgramacao"
                pdf-filename="diaginconsistenciaveiculosprogramacao"
                hide-search
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="primary"
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirResolucao('veiculosProgramacao', item)"
                  >mdi-open-in-new</v-icon>
                </template>
                <span>{{ $t('diagDataInconsistencies.resolveTo.veiculosProgramacao') }}</span>
              </v-tooltip>
            </template>
          </merus-data-table>
        </v-tab-item>
        <v-tab-item>
          <merus-data-table
            :key="`${tableKey}-lp`"
            cod-tabela="DIAGINCONSISTENCIADADOS__LINHAS_PROGRAMACAO"
            :headers="headersLinhasProgramacao"
            :items="linhasProgramacao"
            :loading="loadingLinhasProgramacao"
            item-key="id_linha"
            @update:headers="headersLinhasProgramacao = $event"
          >
            <template v-slot:toolbar>
              <CadastroToolbar
                :title="$t('diagDataInconsistencies.tabs.linesSchedule')"
                :token="token"
                :items="linhasProgramacao"
                csv-title="diaginconsistencialinhasprogramacao"
                :csv-headers="headersLinhasProgramacao"
                :pdf-title="$t('diagDataInconsistencies.tabs.linesSchedule')"
                :pdf-headers="headersLinhasProgramacao"
                pdf-filename="diaginconsistencialinhasprogramacao"
                hide-search
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="primary"
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirResolucao('linhasProgramacao', item)"
                  >mdi-open-in-new</v-icon>
                </template>
                <span>{{ $t('diagDataInconsistencies.resolveTo.linhasProgramacao') }}</span>
              </v-tooltip>
            </template>
          </merus-data-table>
        </v-tab-item>
        <v-tab-item>
          <merus-data-table
            :key="`${tableKey}-lrc`"
            cod-tabela="DIAGINCONSISTENCIADADOS__LINHAS_ROTAS_CERCAS"
            :headers="headersLinhasRotasCercas"
            :items="linhasRotasCercas"
            :loading="loadingLinhasRotasCercas"
            item-key="id_linha"
            @update:headers="headersLinhasRotasCercas = $event"
          >
            <template v-slot:toolbar>
              <CadastroToolbar
                :title="$t('diagDataInconsistencies.tabs.linesRoutesFences')"
                :token="token"
                :items="linhasRotasCercas"
                csv-title="diaginconsistencialinhasrotascercas"
                :csv-headers="headersLinhasRotasCercas"
                :pdf-title="$t('diagDataInconsistencies.tabs.linesRoutesFences')"
                :pdf-headers="headersLinhasRotasCercas"
                pdf-filename="diaginconsistencialinhasrotascercas"
                hide-search
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="primary"
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirResolucao('linhasRotasCercas', item)"
                  >mdi-open-in-new</v-icon>
                </template>
                <span>{{ $t('diagDataInconsistencies.resolveTo.linhasPontosMapa') }}</span>
              </v-tooltip>
            </template>
          </merus-data-table>
        </v-tab-item>
        <v-tab-item>
          <merus-data-table
            v-if="tab === 4"
            :key="`${tableKey}-p`"
            cod-tabela="DIAGINCONSISTENCIADADOS__PASSAGEIROS"
            :headers="headersPassageiros"
            :items="passageiros"
            :loading="loadingPassageiros"
            :server-items-length="passageirosTotal"
            :items-per-page="passageirosNumberOfRows"
            :items-per-page-last-option="passageirosItemsPerPageLastOption"
            :server-sort-by="passageirosServerSortBy"
            :server-sort-desc="passageirosServerSortDesc"
            :extra-headers="headersPassageirosEmpresa"
            :suppress-header-values="passageirosSuppressHeaders"
            item-key="id_pessoa"
            @update:headers="onPassageirosHeadersUpdate"
            @update:options="onPassageirosTableOptions"
            @update:filters="onPassageirosFiltersUpdate"
          >
            <template v-slot:toolbar>
              <CadastroToolbar
                :title="$t('diagDataInconsistencies.tabs.passengers')"
                :token="token"
                :items="passageiros"
                :load-items-for-export="loadPassageirosItemsForExport"
                csv-title="diaginconsistenciapassageiros"
                :csv-headers="headersPassageiros"
                :pdf-title="$t('diagDataInconsistencies.tabs.passengers')"
                :pdf-headers="headersPassageiros"
                pdf-filename="diaginconsistenciapassageiros"
                hide-search
              >
                <template v-slot:extension>
                  <LazySelect
                    ref="passageirosEmpresaSelect"
                    get-url="getEmpresaslazy"
                    :extra-items="semEmpresaExtraItems"
                    text="razao_social"
                    value="id_empresa"
                    :label="$t('diagDataInconsistencies.headers.company')"
                    class="mr-2 passageiros-empresa-filter"
                    @input="onPassageirosEmpresaFilterInput"
                  />
                </template>
              </CadastroToolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="primary"
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirResolucao('passageiros', item)"
                  >mdi-open-in-new</v-icon>
                </template>
                <span>{{ resolvePassageiroTooltip(item) }}</span>
              </v-tooltip>
            </template>
          </merus-data-table>
        </v-tab-item>
        <v-tab-item>
          <merus-data-table
            :key="`${tableKey}-lpt`"
            cod-tabela="DIAGINCONSISTENCIADADOS__LINHAS_PONTOS"
            :headers="headersLinhasPontos"
            :items="linhasPontos"
            :loading="loadingLinhasPontos"
            item-key="id_linha"
            @update:headers="headersLinhasPontos = $event"
          >
            <template v-slot:toolbar>
              <CadastroToolbar
                :title="$t('diagDataInconsistencies.tabs.linesEndpoints')"
                :token="token"
                :items="linhasPontos"
                csv-title="diaginconsistencialinhaspontos"
                :csv-headers="headersLinhasPontos"
                :pdf-title="$t('diagDataInconsistencies.tabs.linesEndpoints')"
                :pdf-headers="headersLinhasPontos"
                pdf-filename="diaginconsistencialinhaspontos"
                hide-search
              />
            </template>
            <template v-slot:item.cod_linha="{ item }">
              <span class="d-inline-flex align-center">
                <v-tooltip bottom v-if="linhaAlertaSemRotaCerca(item)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      color="orange darken-2"
                      class="mr-1"
                      v-bind="attrs"
                      v-on="on"
                    >mdi-alert</v-icon>
                  </template>
                  <span>{{ $t('diagDataInconsistencies.alerts.lineWithoutRouteFence') }}</span>
                </v-tooltip>
                <span>{{ item.cod_linha }}</span>
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="primary"
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirResolucao('linhasPontos', item)"
                  >mdi-open-in-new</v-icon>
                </template>
                <span>{{ $t('diagDataInconsistencies.resolveTo.linhasPontosMapa') }}</span>
              </v-tooltip>
            </template>
          </merus-data-table>
        </v-tab-item>
        <v-tab-item>
          <merus-data-table
            :key="`${tableKey}-f`"
            cod-tabela="DIAGINCONSISTENCIADADOS__FUNCIONARIOS"
            :headers="headersFuncionarios"
            :items="funcionarios"
            :loading="loadingFuncionarios"
            item-key="id_funcionario"
            @update:headers="headersFuncionarios = $event"
          >
            <template v-slot:toolbar>
              <CadastroToolbar
                :title="$t('diagDataInconsistencies.tabs.employees')"
                :token="token"
                :items="funcionarios"
                csv-title="diaginconsistenciafuncionarios"
                :csv-headers="headersFuncionarios"
                :pdf-title="$t('diagDataInconsistencies.tabs.employees')"
                :pdf-headers="headersFuncionarios"
                pdf-filename="diaginconsistenciafuncionarios"
                hide-search
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="primary"
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirResolucao('funcionarios', item)"
                  >mdi-open-in-new</v-icon>
                </template>
                <span>{{ $t('diagDataInconsistencies.resolveTo.funcionarios') }}</span>
              </v-tooltip>
            </template>
          </merus-data-table>
        </v-tab-item>
        <v-tab-item>
          <merus-data-table
            :key="`${tableKey}-lu`"
            cod-tabela="DIAGINCONSISTENCIADADOS__LINHAS_UNIDADES"
            :headers="headersLinhasUnidades"
            :items="linhasUnidades"
            :loading="loadingLinhasUnidades"
            item-key="id_linha"
            @update:headers="headersLinhasUnidades = $event"
          >
            <template v-slot:toolbar>
              <CadastroToolbar
                :title="$t('diagDataInconsistencies.tabs.linesUnits')"
                :token="token"
                :items="linhasUnidades"
                csv-title="diaginconsistencialinhasunidades"
                :csv-headers="headersLinhasUnidades"
                :pdf-title="$t('diagDataInconsistencies.tabs.linesUnits')"
                :pdf-headers="headersLinhasUnidades"
                pdf-filename="diaginconsistencialinhasunidades"
                hide-search
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="primary"
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirResolucao('linhasUnidades', item)"
                  >mdi-open-in-new</v-icon>
                </template>
                <span>{{ $t('diagDataInconsistencies.resolveTo.linhasUnidades') }}</span>
              </v-tooltip>
            </template>
          </merus-data-table>
        </v-tab-item>
        <v-tab-item>
          <merus-data-table
            :key="`${tableKey}-pe`"
            cod-tabela="DIAGINCONSISTENCIADADOS__PASSAGEIROS_EMBARQUE"
            :headers="headersPassageirosEmbarque"
            :items="passageirosEmbarque"
            :loading="loadingPassageirosEmbarque"
            item-key="id_pessoa"
            @update:headers="headersPassageirosEmbarque = $event"
          >
            <template v-slot:toolbar>
              <CadastroToolbar
                :title="$t('diagDataInconsistencies.tabs.passengersBoarding')"
                :token="token"
                :items="passageirosEmbarque"
                csv-title="diaginconsistenciapassageirosembarque"
                :csv-headers="headersPassageirosEmbarque"
                :pdf-title="$t('diagDataInconsistencies.tabs.passengersBoarding')"
                :pdf-headers="headersPassageirosEmbarque"
                pdf-filename="diaginconsistenciapassageirosembarque"
                hide-search
              />
            </template>
            <template v-slot:item.motivo_extenso="{ item }">
              <span class="d-inline-flex align-center">
                <v-icon small color="orange darken-2" class="mr-1">mdi-account-alert</v-icon>
                <span>{{ item.motivo_extenso }}</span>
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="primary"
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirResolucao('passageirosEmbarque', item)"
                  >mdi-open-in-new</v-icon>
                </template>
                <span>{{ resolvePassageiroEmbarqueTooltip(item) }}</span>
              </v-tooltip>
            </template>
          </merus-data-table>
        </v-tab-item>
      </v-tabs-items>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import LazySelect from './Selects/LazySelect.vue';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import LoadingComponent from './LoadingComponent.vue';
import {
  buildRequestParams,
  computePageState,
  fetchAllServerPagesForExport,
  samePageAndSort,
} from '@/utils/serverTablePagination';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const PASSAGEIROS_EMPRESA_FILTER_NONE = -1;
const PASSAGEIROS_SUPPRESS_HEADERS = ['razao_social'];

// Motivo devolvido pela API → tela que resolve aquele elo da cadeia de autorização
// (pessoa → grupo → rota → linha → veículo guia → equipamento FaceID).
const EMBARQUE_RESOLUCAO_PADRAO = { rota: 'Pessoas', tooltip: 'passageirosPessoas' };
const EMBARQUE_RESOLUCAO = {
  SEM_FACEID: { rota: 'Pessoas', tooltip: 'passageirosEmbarqueFaceid' },
  SEM_GRUPO: EMBARQUE_RESOLUCAO_PADRAO,
  GRUPO_SEM_ROTA: { rota: 'Grupos', tooltip: 'passageirosEmbarqueGrupo' },
  ROTA_SEM_LINHA: { rota: 'Rotas', tooltip: 'passageirosEmbarqueRota' },
  LINHA_SEM_VEICULO: { rota: 'Escalas', tooltip: 'passageirosEmbarqueEscala' },
  VEICULO_SEM_FACEID: { rota: 'Equipamentos', tooltip: 'passageirosEmbarqueEquipamento' },
  EQUIPAMENTO_SEM_NIVEL: { rota: 'Equipamentos', tooltip: 'passageirosEmbarqueEquipamento' },
};

// Um request por KPI (mesma ordem dos cards em kpiCards): cada card aparece
// assim que seu COUNT volta, então uma inconsistência lenta em cliente com muito
// dado não segura o resumo inteiro nem derruba tudo por timeout.
const KPI_KEYS = [
  'veiculos_sem_equipamento',
  'veiculos_sem_programacao',
  'linhas_sem_programacao',
  'linhas_sem_rotas_cercas',
  'passageiros_incompletos',
  'linhas_sem_pontos',
  'funcionarios_sem_programacao',
  'linhas_sem_unidade',
  'passageiros_sem_embarque_autorizavel',
];

export default {
  components: {
    MultiplaEscolha,
    LazySelect,
    MerusDataTable,
    CadastroToolbar,
    LoadingComponent,
  },
  data: () => ({
    user: null,
    token: null,
    idEmpresaSelected: null,
    empresaLabelSelected: '',
    idLinhaSelected: [],
    unidadesSelecionadas: [],
    tab: 0,
    kpis: null,
    activeKpiFilter: null,
    loadingResumo: false,
    // Descarta respostas de um resumo anterior quando o filtro muda no meio.
    resumoRequestId: 0,
    resumoErroNotificado: false,
    loadingPdf: false,
    veiculosEquipamentos: [],
    veiculosProgramacao: [],
    linhasProgramacao: [],
    linhasRotasCercas: [],
    passageiros: [],
    passageirosEmpresaFilter: null,
    passageirosTotal: 0,
    passageirosPageNumber: 1,
    passageirosNumberOfRows: 10,
    passageirosServerSortBy: [],
    passageirosServerSortDesc: [],
    passageirosSearchFilters: {},
    passageirosLastItemsPerPageBeforeTodos: null,
    passageirosItemsPerPageLastOption: 1000,
    passageirosDataLoaded: false,
    linhasPontos: [],
    funcionarios: [],
    linhasUnidades: [],
    passageirosEmbarque: [],
    loadingVeiculosEquipamentos: false,
    loadingVeiculosProgramacao: false,
    loadingLinhasProgramacao: false,
    loadingLinhasRotasCercas: false,
    loadingPassageiros: false,
    loadingLinhasPontos: false,
    loadingFuncionarios: false,
    loadingLinhasUnidades: false,
    loadingPassageirosEmbarque: false,
    headersVeiculosEquipamentos: [],
    headersVeiculosProgramacao: [],
    headersLinhasProgramacao: [],
    headersLinhasRotasCercas: [],
    headersPassageiros: [],
    headersPassageirosEmpresa: [],
    passageirosSuppressHeaders: PASSAGEIROS_SUPPRESS_HEADERS,
    headersLinhasPontos: [],
    headersFuncionarios: [],
    headersLinhasUnidades: [],
    headersPassageirosEmbarque: [],
  }),
  computed: {
    tableKey() {
      return `diaginconsistencia-${this.$i18n.locale}`;
    },
    semUnidadeOption() {
      return [{
        id_unidade: -1,
        descricao_unidade: this.$t('routePlanning.fields.noUnit'),
        cod_unidade: 'SU',
      }];
    },
    semEmpresaExtraItems() {
      return [{
        id_empresa: PASSAGEIROS_EMPRESA_FILTER_NONE,
        razao_social: this.$t('routePlanning.fields.noCompany'),
      }];
    },
    hasKpis() {
      return !!this.kpis;
    },
    // Como os KPIs chegam um a um, o PDF só sai quando todos os cards têm valor.
    resumoCompleto() {
      return !!this.kpis && KPI_KEYS.every((key) => this.kpis[key] !== undefined);
    },
    empresaLabel() {
      return this.empresaLabelSelected || '';
    },
    currentTabTitle() {
      const titles = [
        this.$t('diagDataInconsistencies.tabs.vehiclesEquipment'),
        this.$t('diagDataInconsistencies.tabs.vehiclesSchedule'),
        this.$t('diagDataInconsistencies.tabs.linesSchedule'),
        this.$t('diagDataInconsistencies.tabs.linesRoutesFences'),
        this.$t('diagDataInconsistencies.tabs.passengers'),
        this.$t('diagDataInconsistencies.tabs.linesEndpoints'),
        this.$t('diagDataInconsistencies.tabs.employees'),
        this.$t('diagDataInconsistencies.tabs.linesUnits'),
        this.$t('diagDataInconsistencies.tabs.passengersBoarding'),
      ];
      return titles[this.tab] || titles[0];
    },
    kpiCards() {
      if (!this.kpis) return [];
      return [
        {
          key: 'veiculos_sem_equipamento',
          label: this.$t('diagDataInconsistencies.kpis.vehiclesEquipment'),
          value: this.kpis.veiculos_sem_equipamento,
          color: '#c62828',
          tab: 0,
        },
        {
          key: 'veiculos_sem_programacao',
          label: this.$t('diagDataInconsistencies.kpis.vehiclesSchedule'),
          value: this.kpis.veiculos_sem_programacao,
          color: '#ad1457',
          tab: 1,
        },
        {
          key: 'linhas_sem_programacao',
          label: this.$t('diagDataInconsistencies.kpis.linesSchedule'),
          value: this.kpis.linhas_sem_programacao,
          color: '#6a1b9a',
          tab: 2,
        },
        {
          key: 'linhas_sem_rotas_cercas',
          label: this.$t('diagDataInconsistencies.kpis.linesRoutesFences'),
          value: this.kpis.linhas_sem_rotas_cercas,
          color: '#4527a0',
          tab: 3,
        },
        {
          key: 'passageiros_incompletos',
          label: this.$t('diagDataInconsistencies.kpis.passengers'),
          value: this.kpis.passageiros_incompletos,
          color: '#1565c0',
          tab: 4,
        },
        {
          key: 'linhas_sem_pontos',
          label: this.$t('diagDataInconsistencies.kpis.linesEndpoints'),
          value: this.kpis.linhas_sem_pontos,
          color: '#0277bd',
          tab: 5,
        },
        {
          key: 'funcionarios_sem_programacao',
          label: this.$t('diagDataInconsistencies.kpis.employees'),
          value: this.kpis.funcionarios_sem_programacao,
          color: '#ef6c00',
          tab: 6,
        },
        {
          key: 'linhas_sem_unidade',
          label: this.$t('diagDataInconsistencies.kpis.linesUnits'),
          value: this.kpis.linhas_sem_unidade,
          color: '#546e7a',
          tab: 7,
        },
        {
          key: 'passageiros_sem_embarque_autorizavel',
          label: this.$t('diagDataInconsistencies.kpis.passengersBoarding'),
          value: this.kpis.passageiros_sem_embarque_autorizavel,
          color: '#00695c',
          tab: 8,
        },
      ];
    },
  },
  watch: {
    '$i18n.locale'() {
      this.initializeHeaders();
    },
    tab(newTab) {
      if (!this.hasKpis) return;
      this.loadTabData(newTab);
      if (newTab === 4) {
        this.$nextTick(() => this.ensurePassageirosLoaded());
      }
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.token = sessionStorage.getItem('api');
    this.initializeHeaders();
  },
  methods: {
    initializeHeaders() {
      const h = this.$t.bind(this);
      this.headersVeiculosEquipamentos = [
        { text: h('diagDataInconsistencies.headers.vehicle'), value: 'numero_ordem', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.vehicleCode'), value: 'cod_veiculo', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.hasGps'), value: 'tem_gps_extenso', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.gpsCode'), value: 'cod_gps', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.gpsStatus'), value: 'status_gps', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.hasValidator'), value: 'tem_validador_extenso', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.validatorCode'), value: 'cod_validador', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.validatorStatus'), value: 'status_validador', sortable: true, filtrable: true },
      ];
      this.headersVeiculosProgramacao = [
        { text: h('diagDataInconsistencies.headers.vehicle'), value: 'numero_ordem', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.vehicleCode'), value: 'cod_veiculo', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.permanentLine'), value: 'aloca_linha_permanente_extenso', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.line'), value: 'cod_linha_permanente', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.lineName'), value: 'nome_linha_permanente', sortable: true, filtrable: true },
      ];
      this.headersLinhasProgramacao = [
        { text: h('diagDataInconsistencies.headers.line'), value: 'cod_linha', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.lineName'), value: 'nome_linha', sortable: true, filtrable: true },
      ];
      this.headersLinhasRotasCercas = [
        { text: h('diagDataInconsistencies.headers.line'), value: 'cod_linha', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.lineName'), value: 'nome_linha', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.withoutRoute'), value: 'sem_rota_extenso', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.withoutFence'), value: 'sem_cerca_extenso', sortable: true, filtrable: true },
      ];
      // sem_linha_extenso: API marca "Sim" só quando ida E volta são NULL
      this.headersPassageiros = [
        { text: h('passengers.personal.registrationCode'), value: 'matricula', sortable: true, filtrable: true },
        { text: this.$tc('passenger.self', 1), value: 'nome_completo', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.withoutCompany'), value: 'sem_empresa_extenso', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.withoutGroup'), value: 'sem_grupo_extenso', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.withoutLine'), value: 'sem_linha_extenso', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.withoutBoardingFence'), value: 'sem_cerca_embarque_extenso', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.withoutAlightingFence'), value: 'sem_cerca_desembarque_extenso', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.company'), value: 'razao_social', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.unit'), value: 'descricao_unidade', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.lineOutbound'), value: 'cod_linha_ida', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.lineInbound'), value: 'cod_linha_volta', sortable: true, filtrable: true },
      ];
      this.headersPassageirosEmpresa = [{
        text: h('diagDataInconsistencies.headers.company'),
        value: 'razao_social',
        sortable: true,
        filtrable: true,
        show: true,
      }];
      this.headersLinhasPontos = [
        { text: h('diagDataInconsistencies.headers.line'), value: 'cod_linha', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.lineName'), value: 'nome_linha', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.withoutStartPoint'), value: 'sem_ponto_inicial_extenso', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.withoutEndPoint'), value: 'sem_ponto_final_extenso', sortable: true, filtrable: true },
      ];
      this.headersFuncionarios = [
        { text: h('passengers.personal.registrationCode'), value: 'matricula', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.employeeName'), value: 'nome', sortable: true, filtrable: true },
      ];
      this.headersLinhasUnidades = [
        { text: h('diagDataInconsistencies.headers.line'), value: 'cod_linha', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.lineName'), value: 'nome_linha', sortable: true, filtrable: true },
      ];
      // motivo_extenso: primeiro elo quebrado da cadeia de autorização (API traduz pelo locale).
      this.headersPassageirosEmbarque = [
        { text: h('passengers.personal.registrationCode'), value: 'matricula', sortable: true, filtrable: true },
        { text: this.$tc('passenger.self', 1), value: 'nome_completo', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.boardingReason'), value: 'motivo_extenso', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.group'), value: 'nome_grupo', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.faceidCode'), value: 'cod_integracao_faceid', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.company'), value: 'razao_social', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.unit'), value: 'descricao_unidade', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.lineOutbound'), value: 'cod_linha_ida', sortable: true, filtrable: true },
        { text: h('diagDataInconsistencies.headers.lineInbound'), value: 'cod_linha_volta', sortable: true, filtrable: true },
      ];
    },
    onEmpresaInput(id) {
      this.idEmpresaSelected = id;
      this.idLinhaSelected = [];
      if (this.$refs.linhasSelect && this.$refs.linhasSelect.setSelectedItems) {
        this.$refs.linhasSelect.setSelectedItems([]);
      }
      const ref = this.$refs.empresaSelect;
      if (ref && ref.selectedItemCache && id != null && id !== '') {
        const cached = ref.selectedItemCache[id];
        this.empresaLabelSelected = cached && cached.razao_social
          ? cached.razao_social
          : '';
      } else {
        this.empresaLabelSelected = '';
      }
    },
    onPassageirosEmpresaFilterInput(id) {
      if (this.passageirosEmpresaFilter === id) return;
      this.passageirosEmpresaFilter = id;
      this.passageirosPageNumber = 1;
      if (this.hasKpis && this.tab === 4) {
        this.serverTableLoadPassageiros();
      }
    },
    buildFilterBody() {
      // When no lines are selected, send [] so the API does not apply idLinhas.
      // Sending all linhasSelect would exclude entities without a line
      // (e.g. passageiros com ida e volta NULL, veículos sem linha).
      return {
        idEmpresa: this.idEmpresaSelected,
        idUnidades: this.unidadesSelecionadas || [],
        idLinhas: this.idLinhaSelected && this.idLinhaSelected.length
          ? this.idLinhaSelected
          : [],
      };
    },
    buildPassageirosFilterBody() {
      const base = this.buildFilterBody();
      const filter = this.passageirosEmpresaFilter;
      if (filter == null || filter === '') return base;
      if (Number(filter) === PASSAGEIROS_EMPRESA_FILTER_NONE) {
        return { ...base, semEmpresa: true, idEmpresa: null };
      }
      return { ...base, idEmpresa: filter };
    },
    clearTabData() {
      this.veiculosEquipamentos = [];
      this.veiculosProgramacao = [];
      this.linhasProgramacao = [];
      this.linhasRotasCercas = [];
      this.passageiros = [];
      this.passageirosTotal = 0;
      this.passageirosDataLoaded = false;
      this.linhasPontos = [];
      this.funcionarios = [];
      this.linhasUnidades = [];
      this.passageirosEmbarque = [];
    },
    resetPassageirosTableState() {
      this.passageirosPageNumber = 1;
      this.passageirosNumberOfRows = 10;
      this.passageirosServerSortBy = [];
      this.passageirosServerSortDesc = [];
      this.passageirosSearchFilters = {};
      this.passageirosLastItemsPerPageBeforeTodos = null;
      this.passageirosTotal = 0;
      this.passageiros = [];
      this.passageirosDataLoaded = false;
    },
    ensurePassageirosLoaded() {
      if (this.tab !== 4 || this.loadingPassageiros) return;
      if (!this.passageirosDataLoaded) {
        this.serverTableLoadPassageiros();
      }
    },
    loadTabData(tabIndex) {
      // Passageiros: montagem lazy (v-if) dispara update:options ao abrir a aba.
      if (tabIndex === 4) return;
      switch (tabIndex) {
        case 0: this.populaVeiculosEquipamentos(); break;
        case 1: this.populaVeiculosProgramacao(); break;
        case 2: this.populaLinhasProgramacao(); break;
        case 3: this.populaLinhasRotasCercas(); break;
        case 5: this.populaLinhasPontos(); break;
        case 6: this.populaFuncionarios(); break;
        case 7: this.populaLinhasUnidades(); break;
        case 8: this.populaPassageirosEmbarque(); break;
        default: break;
      }
    },
    onPassageirosHeadersUpdate(headers) {
      const next = headers || [];
      if (JSON.stringify(next) === JSON.stringify(this.headersPassageiros)) return;
      this.headersPassageiros = next;
    },
    onPassageirosTableOptions(opts) {
      if (this.tab !== 4) return;
      if (this.loadingPassageiros) return;
      if (!opts) {
        this.serverTableLoadPassageiros(opts);
        return;
      }
      const state = {
        pageNumber: this.passageirosPageNumber,
        numberOfRows: this.passageirosNumberOfRows,
        serverSortBy: this.passageirosServerSortBy,
        serverSortDesc: this.passageirosServerSortDesc,
      };
      if (this.passageirosDataLoaded && samePageAndSort(opts, state)) return;
      this.serverTableLoadPassageiros(opts);
    },
    onPassageirosFiltersUpdate(filters) {
      if (this.tab !== 4) return;
      const next = filters || {};
      if (JSON.stringify(next) === JSON.stringify(this.passageirosSearchFilters)) return;
      this.passageirosSearchFilters = next;
      this.passageirosPageNumber = 1;
      this.serverTableLoadPassageiros();
    },
    serverTableLoadPassageiros(options) {
      if (this.tab !== 4 || this.loadingPassageiros) return Promise.resolve();
      const state = {
        pageNumber: this.passageirosPageNumber,
        numberOfRows: this.passageirosNumberOfRows,
        serverSortBy: this.passageirosServerSortBy,
        serverSortDesc: this.passageirosServerSortDesc,
        searchFilters: this.passageirosSearchFilters,
        lastItemsPerPageBeforeTodos: this.passageirosLastItemsPerPageBeforeTodos,
        total: this.passageirosTotal,
      };
      const { params, page, rowsPerPage, sortByArr, sortDescArr } =
        buildRequestParams(options, state);
      this.loadingPassageiros = true;
      return apiController.request(
        apiController.endpoints.getInconsistenciadadospassageiros,
        {
          data: {
            ...params,
            ...this.buildPassageirosFilterBody(),
          },
          silent: true,
          onSuccess: (response) => {
            const data = response.data;
            if (data && typeof data.total === 'number' && Array.isArray(data.items)) {
              this.passageiros = data.items;
              const updates = computePageState(
                data,
                { page, rowsPerPage, sortByArr, sortDescArr },
                state,
                this.passageirosItemsPerPageLastOption,
              );
              this.passageirosTotal = updates.total;
              this.passageirosPageNumber = updates.pageNumber;
              this.passageirosNumberOfRows = updates.numberOfRows;
              this.passageirosLastItemsPerPageBeforeTodos =
                updates.lastItemsPerPageBeforeTodos;
              this.passageirosServerSortBy = updates.serverSortBy;
              this.passageirosServerSortDesc = updates.serverSortDesc;
              this.passageirosDataLoaded = true;
            } else {
              this.passageiros = Array.isArray(data) ? data : [];
              this.passageirosTotal = this.passageiros.length;
              this.passageirosDataLoaded = true;
            }
            this.loadingPassageiros = false;
          },
          onError: () => {
            this.passageiros = [];
            this.passageirosTotal = 0;
            this.passageirosDataLoaded = false;
            this.loadingPassageiros = false;
          },
        },
      );
    },
    async loadPassageirosItemsForExport(onProgress) {
      return fetchAllServerPagesForExport({
        fetchPage: async (params) => {
          const response = await apiController.request(
            apiController.endpoints.getInconsistenciadadospassageiros,
            {
              data: { ...params, ...this.buildPassageirosFilterBody() },
              silent: true,
            },
          );
          return response.data;
        },
        state: {
          serverSortBy: this.passageirosServerSortBy,
          serverSortDesc: this.passageirosServerSortDesc,
          searchFilters: this.passageirosSearchFilters,
          total: this.passageirosTotal,
        },
        onProgress,
      });
    },
    onKpiClick(card) {
      this.activeKpiFilter = this.activeKpiFilter === card.key ? null : card.key;
      if (card.tab != null) this.tab = card.tab;
    },
    isFlagOn(value) {
      return value === 1 || value === true || value === '1' || value === 'Sim';
    },
    linhaAlertaSemRotaCerca(item) {
      // Mesmo critério da aba "Linhas sem rotas/cercas".
      return this.isFlagOn(item && item.sem_rota)
        || this.isFlagOn(item && item.sem_cerca);
    },
    resolvePassageiroTooltip(item) {
      if (this.isPassageiroResolucaoCadastro(item)) {
        return this.$t('diagDataInconsistencies.resolveTo.passageirosPessoas');
      }
      return this.$t('diagDataInconsistencies.resolveTo.passageiros');
    },
    resolucaoEmbarque(item) {
      return EMBARQUE_RESOLUCAO[item && item.motivo] || EMBARQUE_RESOLUCAO_PADRAO;
    },
    resolvePassageiroEmbarqueTooltip(item) {
      return this.$t(`diagDataInconsistencies.resolveTo.${this.resolucaoEmbarque(item).tooltip}`);
    },
    isPassageiroResolucaoCadastro(item) {
      return !this.isFlagOn(item && item.sem_linha)
        && !this.isFlagOn(item && item.sem_cerca_embarque)
        && !this.isFlagOn(item && item.sem_cerca_desembarque)
        && (this.isFlagOn(item && item.sem_grupo) || this.isFlagOn(item && item.sem_empresa));
    },
    abrirLinha(item, { aba, editar, secao } = {}) {
      if (!item || item.id_linha == null) return;
      const query = { linhasPublicadas: String(item.id_linha) };
      if (aba) query.aba = aba;
      if (editar) {
        query.id_linha = String(item.id_linha);
        query.acao = 'editar';
      }
      if (secao) {
        query.secao = secao;
        // Backup para o CRUDLinhas destacar o campo mesmo se a query for perdida.
        try {
          sessionStorage.setItem('linhasHighlightSecao', String(secao));
          sessionStorage.setItem('linhasHighlightId', String(item.id_linha));
        } catch (e) { /* ignore */ }
      }
      this.$router.push({ name: 'Linhas', query });
    },
    abrirResolucao(tipo, item) {
      if (!item) return;
      switch (tipo) {
        case 'veiculosEquipamentos':
          // Associação GPS/validador fica em Equipamentos (equipamentos.id_veiculo).
          this.$router.push({ name: 'Equipamentos' });
          break;
        case 'veiculosProgramacao':
          // Sem guia/escala e sem linha permanente → programar em Escalas.
          this.$router.push({ name: 'Escalas' });
          break;
        case 'linhasProgramacao':
          // Sem programação → abrir cadastro de escalas padrão.
          this.$router.push({ name: 'Escalas' });
          break;
        case 'linhasRotasCercas':
          this.abrirLinha(item, { aba: 'mapa' });
          break;
        case 'passageiros': {
          if (this.isPassageiroResolucaoCadastro(item)) {
            const query = {};
            if (item.id_pessoa != null) query.id_pessoa = String(item.id_pessoa);
            if (item.matricula) query.matricula = String(item.matricula);
            this.$router.push({ name: 'Pessoas', query });
          } else {
            this.$router.push({
              name: 'Roteirizacao',
              query: { modulo: 'alocacao' },
            });
          }
          break;
        }
        case 'linhasPontos':
          this.abrirLinha(item, { aba: 'mapa' });
          break;
        case 'funcionarios':
          // Programação de motorista/cobrador é em Escalas (não no cadastro).
          this.$router.push({ name: 'Escalas' });
          break;
        case 'linhasUnidades':
          // Unidades da linha são editadas no formulário da linha.
          this.abrirLinha(item, { editar: true, secao: 'unidades' });
          break;
        case 'passageirosEmbarque': {
          const destino = this.resolucaoEmbarque(item);
          const query = {};
          if (destino.rota === 'Pessoas') {
            if (item.id_pessoa != null) query.id_pessoa = String(item.id_pessoa);
            if (item.matricula) query.matricula = String(item.matricula);
          }
          this.$router.push({ name: destino.rota, query });
          break;
        }
        default:
          break;
      }
    },
    populaRelatorio() {
      this.passageirosEmpresaFilter = null;
      if (this.$refs.passageirosEmpresaSelect && this.$refs.passageirosEmpresaSelect.onClear) {
        this.$refs.passageirosEmpresaSelect.onClear();
      }
      this.activeKpiFilter = null;
      this.clearTabData();
      this.resetPassageirosTableState();
      this.populaResumo();
      this.loadTabData(this.tab);
      if (this.tab === 4) {
        this.$nextTick(() => this.ensurePassageirosLoaded());
      }
    },
    populaResumo() {
      const requisicao = this.resumoRequestId + 1;
      this.resumoRequestId = requisicao;
      // {} (e não null) já libera a seção: os cards sem valor mostram spinner.
      this.kpis = {};
      this.resumoErroNotificado = false;
      this.loadingResumo = true;
      const filtros = this.buildFilterBody();
      KPI_KEYS.forEach((key) => {
        apiController.request(apiController.endpoints.getInconsistenciadadosresumo, {
          data: { ...filtros, kpis: [key] },
          // silent para não repetir o mesmo erro nove vezes; a notificação sai
          // uma vez só em recebeKpi.
          silent: true,
          onSuccess: (response) => {
            const kpis = (response.data && response.data.kpis) || {};
            this.recebeKpi(requisicao, key, kpis[key]);
          },
          // null marca o card como indisponível; os outros seguem carregando.
          onError: (error) => { this.recebeKpi(requisicao, key, null, error); },
        }).catch(() => {});
      });
    },
    recebeKpi(requisicao, key, valor, error) {
      if (requisicao !== this.resumoRequestId) return;
      this.$set(this.kpis, key, valor == null ? null : valor);
      // Libera a tela no primeiro retorno; o resto dos cards carrega à vista.
      this.loadingResumo = false;
      if (error && !this.resumoErroNotificado) {
        this.resumoErroNotificado = true;
        EventBus.$emit('show-error', { error });
      }
    },
    populaVeiculosEquipamentos() {
      this.loadingVeiculosEquipamentos = true;
      apiController.request(apiController.endpoints.getInconsistenciadadosveiculosequipamentos, {
        data: this.buildFilterBody(),
        onSuccess: (response) => {
          this.veiculosEquipamentos = response.data || [];
          this.loadingVeiculosEquipamentos = false;
        },
        onError: () => { this.loadingVeiculosEquipamentos = false; },
      });
    },
    populaVeiculosProgramacao() {
      this.loadingVeiculosProgramacao = true;
      apiController.request(apiController.endpoints.getInconsistenciadadosveiculosprogramacao, {
        data: this.buildFilterBody(),
        onSuccess: (response) => {
          this.veiculosProgramacao = response.data || [];
          this.loadingVeiculosProgramacao = false;
        },
        onError: () => { this.loadingVeiculosProgramacao = false; },
      });
    },
    populaLinhasProgramacao() {
      this.loadingLinhasProgramacao = true;
      apiController.request(apiController.endpoints.getInconsistenciadadoslinhasprogramacao, {
        data: this.buildFilterBody(),
        onSuccess: (response) => {
          this.linhasProgramacao = response.data || [];
          this.loadingLinhasProgramacao = false;
        },
        onError: () => { this.loadingLinhasProgramacao = false; },
      });
    },
    populaLinhasRotasCercas() {
      this.loadingLinhasRotasCercas = true;
      apiController.request(apiController.endpoints.getInconsistenciadadoslinhasrotacercas, {
        data: this.buildFilterBody(),
        onSuccess: (response) => {
          this.linhasRotasCercas = response.data || [];
          this.loadingLinhasRotasCercas = false;
        },
        onError: () => { this.loadingLinhasRotasCercas = false; },
      });
    },
    populaLinhasPontos() {
      this.loadingLinhasPontos = true;
      apiController.request(apiController.endpoints.getInconsistenciadadoslinhaspontos, {
        data: this.buildFilterBody(),
        onSuccess: (response) => {
          this.linhasPontos = response.data || [];
          this.loadingLinhasPontos = false;
        },
        onError: () => { this.loadingLinhasPontos = false; },
      });
    },
    populaFuncionarios() {
      this.loadingFuncionarios = true;
      apiController.request(apiController.endpoints.getInconsistenciadadosfuncionarios, {
        data: this.buildFilterBody(),
        onSuccess: (response) => {
          this.funcionarios = response.data || [];
          this.loadingFuncionarios = false;
        },
        onError: () => { this.loadingFuncionarios = false; },
      });
    },
    populaLinhasUnidades() {
      this.loadingLinhasUnidades = true;
      apiController.request(apiController.endpoints.getInconsistenciadadoslinhasunidades, {
        data: this.buildFilterBody(),
        onSuccess: (response) => {
          this.linhasUnidades = response.data || [];
          this.loadingLinhasUnidades = false;
        },
        onError: () => { this.loadingLinhasUnidades = false; },
      });
    },
    populaPassageirosEmbarque() {
      this.loadingPassageirosEmbarque = true;
      apiController.request(apiController.endpoints.getInconsistenciadadospassageirosembarque, {
        data: this.buildFilterBody(),
        onSuccess: (response) => {
          this.passageirosEmbarque = response.data || [];
          this.loadingPassageirosEmbarque = false;
        },
        onError: () => { this.loadingPassageirosEmbarque = false; },
      });
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    resolvePdfEl(ref) {
      if (!ref) return null;
      const target = Array.isArray(ref) ? ref[0] : ref;
      if (!target) return null;
      return target.$el || target;
    },
    html2canvasOptions(el) {
      const width = Math.max(el.scrollWidth, el.clientWidth, 1200);
      const height = Math.max(el.scrollHeight, el.clientHeight, 1);
      const maxEdge = 8000;
      const scale = Math.min(1.5, maxEdge / Math.max(width, height));
      return {
        scale: Math.max(1, scale),
        useCORS: true,
        allowTaint: true,
        logging: false,
        backgroundColor: '#ffffff',
        scrollX: 0,
        scrollY: 0,
        width,
        height,
        windowWidth: width,
        windowHeight: height,
        ignoreElements: (node) =>
          node.classList && node.classList.contains('pdf-export-overlay'),
      };
    },
    addCanvasPagesToPdf(doc, canvas, { addPageBefore = false, title = '' } = {}) {
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 10;
      const titleSpace = title ? 8 : 0;
      const usableWidth = pageWidth - margin * 2;
      const usableHeight = pageHeight - margin * 2 - titleSpace;
      const imgWidth = usableWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const imgData = canvas.toDataURL('image/jpeg', 0.85);

      let heightLeft = imgHeight;
      let y = margin + titleSpace;

      if (addPageBefore) doc.addPage();
      if (title) {
        doc.setFontSize(12);
        doc.setTextColor(40);
        doc.text(String(title), margin, margin + 4);
      }
      doc.addImage(imgData, 'JPEG', margin, y, imgWidth, imgHeight);
      heightLeft -= usableHeight;

      while (heightLeft > 0) {
        y = margin - (imgHeight - heightLeft);
        doc.addPage();
        doc.addImage(imgData, 'JPEG', margin, y, imgWidth, imgHeight);
        heightLeft -= usableHeight;
      }
    },
    async captureElToPdf(doc, ref, { addPageBefore = true, title = '' } = {}) {
      const el = this.resolvePdfEl(ref);
      if (!el || typeof el.getBoundingClientRect !== 'function') return false;
      el.scrollIntoView({ behavior: 'auto', block: 'start' });
      await this.$nextTick();
      await this.sleep(400);
      const canvas = await html2canvas(el, this.html2canvasOptions(el));
      this.addCanvasPagesToPdf(doc, canvas, { addPageBefore, title });
      return true;
    },
    writePdfCoverPage(doc) {
      const margin = 14;
      doc.setFontSize(18);
      doc.setTextColor(25, 118, 210);
      doc.text(this.$t('diagDataInconsistencies.exportPdfTitle'), margin, 24);

      doc.setFontSize(11);
      doc.setTextColor(80);

      let y = 38;
      if (this.empresaLabel) {
        doc.text(`${this.$tc('company.self', 1)}: ${this.empresaLabel}`, margin, y);
        y += 8;
      }

      doc.text(
        `${this.$t('diagDataInconsistencies.exportPdfTab')}: ${this.currentTabTitle}`,
        margin,
        y
      );
      y += 8;

      const emitted = new Date();
      const emittedStr = emitted.toLocaleString(this.$i18n.locale || 'pt-BR');
      doc.text(`${this.$t('diagDataInconsistencies.exportPdfEmittedAt')}: ${emittedStr}`, margin, y);

      doc.setFontSize(10);
      doc.setTextColor(120);
      doc.text(this.$t('diagDataInconsistencies.exportPdfHint'), margin, y + 16, { maxWidth: 270 });
    },
    async exportarAnalisePdf() {
      if (!this.resumoCompleto || this.loadingPdf) return;
      this.loadingPdf = true;

      try {
        await this.$nextTick();
        await this.sleep(300);

        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
          compress: true,
        });
        this.writePdfCoverPage(doc);

        const ok = await this.captureElToPdf(doc, this.$refs.sectionContent, {
          addPageBefore: true,
          title: this.currentTabTitle,
        });
        if (!ok) {
          throw new Error('Conteúdo não encontrado para exportar');
        }

        const stamp = new Date().toISOString().replace(/[:.]/g, '-');
        doc.save(`inconsistenciadados_${stamp}.pdf`);
      } catch (err) {
        console.error('PDF export failed', err);
        // eslint-disable-next-line no-alert
        window.alert(this.$t('diagDataInconsistencies.exportPdfError'));
      } finally {
        this.loadingPdf = false;
      }
    },
  },
};
</script>

<style>
.pdf-export-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
}

.passageiros-empresa-filter {
  max-width: 280px;
  min-width: 200px;
}
</style>
